export default "__VITE_ASSET__CbkcNC60__"